import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import BreadCrumbsGeneric from "../../../components/Nav/BreadCrumbsGeneric";
import { ArrowSmUpIcon } from "@heroicons/react/solid";
import { UseContextApp } from "../../../Global/Context/appContext";
import banner from "../../../assets/banner_marca.png";
import { colors } from "../../../propsType/Colors";
import { TabNavegation } from "../../../propsType/TabNavegation";
function DetailsDatos() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname;
  const [{ user }] = UseContextApp();
  const [deatils, setDeatils] = useState(null);
  const { tabsHogarDetails, tabsEmpresaDetails } = TabNavegation(pathName)
  const [tabs, setTabs] = useState(user?.datos?.tipoCliente === 'Hogar' ? tabsHogarDetails : tabsEmpresaDetails || [''])


  const stats = [
    {
      name: "Número de Cuenta",
      stat: deatils?.cuenta,
      previousStat: "",
      change: "",
      changeType: "",
    },
    {
      name: "Número de Contrato",
      stat: deatils?.contrato,
      previousStat: "",
      change: "",
      changeType: "",
    },
    {
      name: "Correo",
      stat: user?.datos?.maskEmail,
      previousStat: "",
      change: deatils?.status,
      changeType: "increase",
    },
  ];

  useEffect(() => {
     setDeatils(location?.state?.data);
   }, [location]);
  function handleChangeRoute(e) {

    let route = e.target.value;
    switch (route) {
      case "Servicios Internet":
        navigate("/cuenta/servicio-de-internet");
        break;
      case "Servicios Datos":
        navigate("/cuenta/servicio-de-datos");
        break;
      case "Servicios Televisión Streaming":
        navigate("/cuenta/servicio-de-streaming");
        break;
      case "Servicios Telefonía":
        navigate("/cuenta/servicio-de-telefonia");
        break;
      default:
        break;
    }
  }
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }
  return (
    <>
      <div className=" relative bg-[#f3f4f6]">
        <div className="flex max-w-7xl mx-auto  pt-6 justify-center min-h-screen">
          <div className="flex lg:w-full gap-5 p-[20px] lg:p-2 overflow-auto flex-col">
            <BreadCrumbsGeneric locations={pathName} />
            <div>
              <div>
                <div className="sm:hidden">
                  <label htmlFor="tabs" className="sr-only">
                    Select a tab
                  </label>
                  <select
                    id="tabs"
                    name="tabs"
                    onChange={handleChangeRoute}
                    className="block w-full h-11 p-[10px] shadow focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                    defaultValue={tabs.find((tab) => tab.current).name}
                  >
                    {tabs.map((tab) => (
                      <option key={tab.name}>{tab.name}</option>
                    ))}
                  </select>
                </div>
                <div className="hidden sm:block">
                  <nav
                    className="relative z-0 rounded-lg shadow flex divide-x divide-gray-200"
                    aria-label="Tabs"
                  >
                    {tabs.map((tab, tabIdx) => (
                      <Link
                        key={tab.name}
                        to={tab.href}
                        className={classNames(
                          tab.current
                            ? "text-gray-900"
                            : "text-gray-500 hover:text-gray-700",
                          tabIdx === 0 ? "rounded-l-lg" : "",
                          tabIdx === tabs.length - 1 ? "rounded-r-lg" : "",
                          "group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
                        )}
                        aria-current={tab.current ? "page" : undefined}
                      >
                        <span>{tab.name}</span>
                        <span
                          aria-hidden="true"
                          className={classNames(
                            tab.current
                              ? `bg-[${colors.lightBlue}]`
                              : "bg-transparent",
                            "absolute inset-x-0 bottom-0 h-0.5"
                          )}
                        />
                      </Link>
                    ))}
                  </nav>
                </div>
              </div>
            </div>
            <div>
              <dl className="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x">
                {stats.map((item, index) => (
                  <div
                    key={item.name}
                    className="px-4 flex justify-between items-center py-5 sm:p-6"
                  >
                    <div>
                      <dt className="text-base flex justify-between items-center font-normal text-gray-900 ">
                        {item.name === "Correo" ? (
                          <>
                            <div> {item.name}</div>
                          </>
                        ) : (
                          <>{item.name}</>
                        )}
                      </dt>
                      <dd className="mt-1 flex justify-between items-center md:block lg:flex">
                        <div
                          className={`flex items-baseline text-2xl font-semibold text-[${colors.lightBlue}] `}
                        >
                          {item.stat}
                          <span className="ml-2 text-sm font-medium text-gray-500">
                            {" "}
                            {item.previousStat}
                          </span>
                        </div>
                      </dd>
                    </div>
                  </div>
                ))}
              </dl>
            </div>
            <div>
              <main>
                <div className=" max-w-3xl mx-auto grid grid-cols-1 gap-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-5">
                  <div className="space-y-6 lg:col-start-1 lg:col-span-3">
                    <section aria-labelledby="applicant-information-title">
                      <div className="bg-white shadow h-full sm:rounded-lg">
                        <div className="px-4 py-5 sm:px-6">
                          <h2
                            id="applicant-information-title"
                            className="text-lg leading-6 font-medium text-gray-900"
                          >
                            Detalles de Servicio
                          </h2>
                          <p className="mt-1 max-w-2xl text-sm text-gray-500">
                                Servicios Datos
                              </p>
                        </div>
                        <div className="border-t border-gray-200 px-4 h-full py-5 sm:px-6 ">
                          <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                            <div className="sm:col-span-1">
                              <dt className="text-sm font-medium text-gray-500">
                                Paquete
                              </dt>
                              <dd className="mt-1 text-sm text-gray-900">
                                {deatils?.paquete}{" "}
                              </dd>
                            </div>
                            <div className="sm:col-span-1">
                              <dt className="text-sm font-medium text-gray-500">
                                Tecnología
                              </dt>
                              <dd className="mt-1 text-sm text-gray-900">
                                {deatils?.tecnologia}{" "}
                              </dd>
                            </div>
                            <div className="sm:col-span-1">
                              <dt className="text-sm font-medium text-gray-500">
                                Titular
                              </dt>
                              <dd className="mt-1 text-sm text-gray-900">
                                {user?.datos?.nombreApellido}{" "}
                              </dd>
                            </div>
                            <div className="sm:col-span-1">
                              <dt className="text-sm font-medium text-gray-500">
                                Estatus
                              </dt>

                              <dd className="mt-1 flex shadow-md text-sm px-[5px] py-[2px] bg-green-100 w-[30%] rounded-full text-center text-green-800">
                                <ArrowSmUpIcon
                                  className="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-green-500"
                                  aria-hidden="true"
                                />
                                {deatils?.status}{" "}
                              </dd>
                            </div>
                            <div className="sm:col-span-1">
                              <dt className="text-sm font-medium text-gray-500">
                                Ciudad
                              </dt>
                              <dd className="mt-1 text-sm text-gray-900">
                                Caracas{" "}
                              </dd>
                            </div>
                          </dl>
                        </div>
                        <div>
                          <Link
                            state={{ data: { nroCuenta: deatils?.cuenta } }}
                            to={"/cuenta/pagos/estado-de-cuenta"}
                            className={`block bg-[${colors.lightBlue}] text-md font-medium hover:bg-[${colors.darkBlue}] duration-300 easy hover:text-white text-white text-center px-4 py-4  sm:rounded-b-lg`}
                          >
                            Ver Estado de Cuenta
                          </Link>
                        </div>
                      </div>
                    </section>
                  </div>
                  <div className="lg:col-span-2">
                    <img
                      className="w-full  cover rounded-[10px] h-[381px] shadow-lg"
                      src={banner}
                      alt=""
                    />
                  </div>
                </div>
              </main>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DetailsDatos;
